module.exports = __webpack_public_path__ + "img/1-1.e907f409.jpg";